export
const name: string = "PointId";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform mediump vec2 u_glyph_size;
    uniform sampler2D    u_texture;
`;

export
const varyings: string = `
    varying vec2         v_tex_coord;
    varying vec4         v_object_id;
`;

export
const implementation: string = `
    void main(void)
    {
        lowp vec4 texColor = texture2D(u_texture, v_tex_coord + ((gl_PointCoord.xy * u_glyph_size)));

        if (texColor.a < 0.2) discard;

    #ifdef CLIPPING_PLANE
        resolveClippingPlane();
    #endif

        gl_FragColor = v_object_id;
    }
`;
